import api, { setHeaderToken, removeHeaderToken } from '../../../apis/Api'

import router from '@/router'
import { allMixin } from '@/mixins/allMixin.js'

export default {
	namespaced: true,
	state: {
		Config: [],
		MyAccount: [],
		DCLocation: [],
		DataSecond: [],
		DataThird: [],
		DataPayloadObject: {
			user_profile: { attachment: '' }
		},
		DataPayloadObject2: {},
		DataPayload: [],
		countDataPayload: 0,
		DataPayload2: [],
		DataPayload3: [],
		DataPayload4: [],
		notif: [],
		countDCLocation: 0,
		countDataSecond: 0,
		countEmergencies: 0,
		// -------------------------------------
		buildings: [],
		countBuildings: 0,
		floors: [],
		countFloors: 0,
		rooms: [],
		countRooms: 0,
		racks: []
	},
	getters: {
		getConfig(state) {
			return state.Config
		},
		getMyAccount(state) {
			return state.MyAccount
		},
		getcountEmergencies(state) {
			return state.countEmergencies
		},
		getDCLocation(state) {
			return state.DCLocation
		},
		getDataSecond(state) {
			return state.DataSecond
		},
		getDataThird(state) {
			return state.DataThird
		},
		getDataPayloadObject(state) {
			return state.DataPayloadObject
		},
		getDataPayloadObject2(state) {
			return state.DataPayloadObject2
		},
		getDataPayload(state) {
			return state.DataPayload
		},
		getcountDataPayload(state) {
			return state.countDataPayload
		},
		getDataPayload2(state) {
			return Array.isArray(state.DataPayload2) ? state.DataPayload2 : []
		},
		getDataPayload3(state) {
			return state.DataPayload3
		},
		getDataPayload4(state) {
			return state.DataPayload4
		},
		getCountDCLocation(state) {
			return state.countDCLocation
		},
		getCountDataSecond(state) {
			return state.countDataSecond
		},
		getNotif(state) {
			return state.notif
		},
		// -------------------------------------
		getBuildings(state) {
			return state.buildings
		},
		getFloors(state) {
			return state.floors
		},
		getRooms(state) {
			return state.rooms
		},
		getCountBuildings(state) {
			return state.countBuildings
		},
		getCountFloors(state) {
			return state.countFloors
		},
		getCountRooms(state) {
			return state.countRooms
		},
		getRacks(state) {
			return state.racks
		}
	},
	mutations: {
		setConfig(state, payload) {
			state.Config = payload
		},
		setMyAccount(state, payload) {
			state.MyAccount = payload
		},
		setcountEmergencies(state, payload) {
			state.countEmergencies = payload
		},
		setDCLocation(state, payload) {
			state.DCLocation = payload
		},
		setDataSecond(state, payload) {
			state.DataSecond = payload
		},
		setDataThird(state, payload) {
			state.DataThird = payload
		},
		setDataPayloadObject(state, payload) {
			state.DataPayloadObject = payload
		},
		setDataPayloadObject2(state, payload) {
			state.DataPayloadObject2 = payload
		},
		setDataPayload(state, payload) {
			state.DataPayload = payload
		},
		setcountDataPayload(state, payload) {
			state.countDataPayload = payload
		},
		setDataPayload2(state, payload) {
			state.DataPayload2 = payload
		},
		setDataPayload3(state, payload) {
			state.DataPayload3 = payload
		},
		setDataPayload4(state, payload) {
			state.DataPayload4 = payload
		},

		setCountDCLocation(state, payload) {
			state.countDCLocation = payload
		},
		setCountDataSecond(state, payload) {
			state.countDataSecond = payload
    },
    setNotif(state, payload){
			state.notif = payload
    },
		// -------------------------------------
		setBuildings(state, payload) {
			state.buildings = payload
		},
		setFloors(state, payload) {
			state.floors = payload
		},
		setRooms(state, payload) {
			state.rooms = payload
		},
		setCountBuildings(state, payload) {
			state.countBuildings = payload
		},
		setCountFloors(state, payload) {
			state.countFloors = payload
		},
		setCountRooms(state, payload) {
			state.countRooms = payload
		},
		setRacks(state, payload) {
			state.racks = payload
		}
	},
	actions: {
		// getDetail({ state, commit, dispatch, rootGetters }, payload) {
		// 	dispatch('setLoading', true)
		// 	let token = localStorage.getItem('token')
		// 	return new Promise((resolve, reject) => {
		// 		api({
		// 			method: 'get',
		// 			url: payload.url,
		// 			data: payload.params,
		// 			headers: {
		// 				Authorization: 'Bearer ' + token
		// 			}
		// 		})
		// 			.then((res) => {
		// 				resolve(res)
		// 				if (res.respond.status == 'success') {
		// 					commit('setRequestDetail', res.respond.data)
		// 				} else if (res.respond.status == 'forbidden') {
		// 					allMixin.methods.removeSession()
		// 					router.push(`/login`).catch(() => {})
		// 				}
		// 				dispatch('setLoading', false)
		// 			})
		// 			.catch((err) => {
		// 				reject(err)
		// 				console.log('authjs=err' + err)
		// 				dispatch('setLoading', false)
		// 				return false
		// 			})
		// 	})
		// },

		getData({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			return new Promise((resolve, reject) => {
				api({
					method: 'get',
					url: payload.url,
					params: payload.params,
					headers: {
						Authorization: 'Bearer ' + token
					}
				})
					.then((res) => {
						resolve(res.payload)
						if (res.statusCode == 200) {
							commit('setDCLocation', res.payload.Records)
							commit('setCountDCLocation', res.payload.Count)
						}
						dispatch('setLoading', false)
					})
					.catch((error) => {
						if (error.response) {
							console.log(error.response.data)
							console.log(error.response.status)
							console.log(error.response.headers)
						}
						// Invalid Token
						if (error.response.status == 403) {
							allMixin.methods.removeSession()
							router.push(`/login`).catch(() => {})
						}
						dispatch('setLoading', false)
						reject(error)
						return false
					})
			})
		},

		getDataSecond({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			api({
				method: 'get',
				url: payload.url,
				params: payload.params,
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
				.then((res) => {
					console.log(res)
					if (res.statusCode == 200) {
						commit('setDataSecond', res.payload.Records)
						commit('setCountDataSecond', res.payload.Count)
					}
					dispatch('setLoading', false)
				})
				.catch((err) => {
					dispatch('setLoading', false)
					return false
				})
		},
		getDataThird({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			api({
				method: 'get',
				url: payload.url,
				params: payload.params,
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
				.then((res) => {
					console.log(res)
					if (res.statusCode == 200) {
						commit('setDataThird', res.payload)
					}
					dispatch('setLoading', false)
				})
				.catch((error) => {
					if (error.response) {
						console.log(error.response.data)
						console.log(error.response.status)
						console.log(error.response.headers)
					}
					// Invalid Token
					if (error.response.status == 403) {
						allMixin.methods.removeSession()
						router.push(`/login`).catch(() => {})
					}
					dispatch('setLoading', false)
					return false
				})
		},
		getDataPayload({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			return new Promise((resolve, reject) => {
				api({
					method: 'get',
					url: payload.url,
					params: payload.params,
					headers: {
						Authorization: 'Bearer ' + token
					}
				})
					.then((res) => {
						resolve(res)
						console.log(res)
						if (res.statusCode == 200) {
							commit('setDataPayloadObject', res.payload)
							commit('setDataPayload', res.payload)
							commit('setcountDataPayload', res.count)
						}
						dispatch('setLoading', false)
					})
					.catch((error) => {
						if (error.response) {
							console.log(error.response.data)
							console.log(error.response.status)
							console.log(error.response.headers)
						}
						// Invalid Token
						if (error.response.status == 403) {
							allMixin.methods.removeSession()
							router.push(`/login`).catch(() => {})
						}
						dispatch('setLoading', false)
						reject(error)
						return false
					})
			})
		},
		getDataPayload2({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			return new Promise((resolve, reject) => {
				api({
					method: 'get',
					url: payload.url,
					params: payload.params,
					headers: {
						Authorization: 'Bearer ' + token
					}
				})
					.then((res) => {
						resolve(res)
						console.log(res)
						if (res.statusCode == 200) {
							commit('setDataPayloadObject', res.payload)
							commit('setDataPayloadObject2', res.payload)
							commit('setDataPayload2', res.payload)
						}
						dispatch('setLoading', false)
					})
					.catch((error) => {
						if (error.response) {
							console.log(error.response.data)
							console.log(error.response.status)
							console.log(error.response.headers)
						}
						// Invalid Token
						if (error.response.status == 403) {
							allMixin.methods.removeSession()
							router.push(`/login`).catch(() => {})
						}
						dispatch('setLoading', false)
						reject(error)
						return false
					})
			})
		},
		getDataPayload3({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			return new Promise((resolve, reject) => {
				api({
					method: 'get',
					url: payload.url,
					params: payload.params,
					headers: {
						Authorization: 'Bearer ' + token
					}
				})
					.then((res) => {
						resolve(res)
						console.log(res)
						if (res.statusCode == 200) {
							commit('setDataPayload3', res.payload)
						}
						dispatch('setLoading', false)
					})
					.catch((error) => {
						if (error.response) {
							console.log(error.response.data)
							console.log(error.response.status)
							console.log(error.response.headers)
						}
						// Invalid Token
						if (error.response.status == 403) {
							allMixin.methods.removeSession()
							router.push(`/login`).catch(() => {})
						}
						dispatch('setLoading', false)
						reject(error)
						return false
					})
			})
		},
		getDataPayload4({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			return new Promise((resolve, reject) => {
				api({
					method: 'get',
					url: payload.url,
					params: payload.params,
					headers: {
						Authorization: 'Bearer ' + token
					}
				})
					.then((res) => {
						resolve(res)
						console.log(res)
						if (res.statusCode == 200) {
							commit('setDataPayload4', res.payload)
						}
						dispatch('setLoading', false)
					})
					.catch((error) => {
						if (error.response) {
							console.log(error.response.data)
							console.log(error.response.status)
							console.log(error.response.headers)
						}
						// Invalid Token
						if (error.response.status == 403) {
							allMixin.methods.removeSession()
							router.push(`/login`).catch(() => {})
						}
						dispatch('setLoading', false)
						reject(error)
						return false
					})
			})
		},
		getCountEmergencies({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			return new Promise((resolve, reject) => {
				api({
					method: 'get',
					url: payload.url,
					params: payload.params,
					headers: {
						Authorization: 'Bearer ' + token
					}
				})
					.then((res) => {
						resolve(res)
						console.log(res)
						if (res.statusCode == 200) {
							commit('setcountEmergencies', res.payload.Count)
						}
						dispatch('setLoading', false)
					})
					.catch((error) => {
						if (error.response) {
							console.log(error.response.data)
							console.log(error.response.status)
							console.log(error.response.headers)
						}
						// Invalid Token
						if (error.response.status == 403) {
							allMixin.methods.removeSession()
							router.push(`/login`).catch(() => {})
						}
						dispatch('setLoading', false)
						reject(error)
						return false
					})
			})
		},
		getMyAccount({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			return new Promise((resolve, reject) => {
				api({
					method: 'get',
					url: payload.url,
					params: payload.params,
					headers: {
						Authorization: 'Bearer ' + token
					}
				})
					.then((res) => {
						resolve(res)
						console.log(res)
						if (res.statusCode == 200) {
							commit('setMyAccount', res.payload)
						}
						dispatch('setLoading', false)
					})
					.catch((error) => {
						if (error.response) {
							console.log(error.response.data)
							console.log(error.response.status)
							console.log(error.response.headers)
						}
						// Invalid Token
						if (error.response.status == 403) {
							allMixin.methods.removeSession()
							router.push(`/login`).catch(() => {})
						}
						dispatch('setLoading', false)
						reject(error)
						return false
					})
			})
		},
		getConfig({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			return new Promise((resolve, reject) => {
				api({
					method: 'get',
					url: payload.url,
					params: payload.params,
					headers: {
						Authorization: 'Bearer ' + token
					}
				})
					.then((res) => {
						resolve(res)
						console.log(res)
						if (res.statusCode == 200) {
							commit('setConfig', res.payload)
						}
						dispatch('setLoading', false)
					})
					.catch((error) => {
						if (error.response) {
							console.log(error.response.data)
							console.log(error.response.status)
							console.log(error.response.headers)
						}
						// Invalid Token
						if (error.response.status == 403) {
							allMixin.methods.removeSession()
							router.push(`/login`).catch(() => {})
						}
						dispatch('setLoading', false)
						reject(error)
						return false
					})
			})
		},
		getNotif({ state, commit, dispatch, rootGetters }, payload) {
			// dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			return new Promise((resolve, reject) => {
				api({
					method: 'get',
					url: payload.url,
					params: payload.params,
					headers: {
						Authorization: 'Bearer ' + token
					}
				})
					.then((res) => {
						resolve(res)
						console.log(res)
						if (res.statusCode == 200) {
							commit('setNotif', res.payload)
						}
						// dispatch('setLoading', false)
					})
					.catch((error) => {
						if (error.response) {
							console.log(error.response.data)
							console.log(error.response.status)
							console.log(error.response.headers)
						}
						// Invalid Token
						if (error.response.status == 403) {
							allMixin.methods.removeSession()
							router.push(`/login`).catch(() => {})
						}
						// dispatch('setLoading', false)
						reject(error)
						return false
					})
			})
		},
		createNewRecord({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			return new Promise((resolve, reject) => {
				api({
					method: payload.method,
					url: payload.url,
					data: payload.data,
					withCredentials: true,
					headers: {
						Authorization: 'Bearer ' + token
					}
				})
					.then((res) => {
						resolve(res)
						dispatch('setLoading', false)
					})
					.catch((error) => {
						if (error.response.status == 400) {
							alert(error.response.data.payload)
						}
						if (error.response) {
							console.log(error.response.data)
							console.log(error.response.status)
							console.log(error.response.headers)
						}
						// Invalid Token
						if (error.response.status == 403) {
							allMixin.methods.removeSession()
							router.push(`/login`).catch(() => {})
						}
						reject(error)
						dispatch('setLoading', false)
						return false
					})
			})
		},

		upload({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			return new Promise((resolve, reject) => {
				api({
					// baseURL: config("api.baseUrl_storage"),
					method: 'post',
					url: 'storage/image/set',
					data: payload,
					withCredentials: true,
					headers: {
						Authorization: 'Bearer ' + token,
						'Content-Type': 'multipart/form-data'
					}
				})
					.then((res) => {
						resolve(res)
						dispatch('setLoading', false)
					})
					.catch((err) => {
						console.log('authjs=err' + err)
						reject(err)
						dispatch('setLoading', false)
						return false
					})
			})
		},

		donlotCSV({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			api({
				// baseURL: config("api.baseUrl_storage"),
				method: 'get',
				url: payload.url,
				params: payload.params,
				responseType: 'blob',
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
				.then((res) => {
					const blob = new Blob([res], { type: 'text/csv;charset=utf-8;' })
					const url = window.URL.createObjectURL(blob)

					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', payload.filename) // nama file
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)

					dispatch('setLoading', false)
				})
				.catch((err) => {
					console.log('authjs=err' + err)
					dispatch('setLoading', false)
					return false
				})
		},

		// -------------------------------------

		getBuildings({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			api({
				method: 'get',
				url: payload.url,
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
				.then((res) => {
					if (res.respond.status == 'success') {
						commit('setBuildings', res.respond.data)
						commit('setCountBuildings', res.respond.data.count)
					} else if (res.respond.status == 'forbidden') {
						allMixin.methods.removeSession()
						router.push(`/login`).catch(() => {})
					}
					dispatch('setLoading', false)
				})
				.catch((err) => {
					console.log('authjs=err' + err)
					dispatch('setLoading', false)
					return false
				})
		},
		getFloors({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			api({
				method: 'get',
				url: payload.url,
				// url: `location/area/floor?page_number=${payload.page_number}&page_size=${payload.page_size}`,
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
				.then((res) => {
					if (res.respond.status == 'success') {
						commit('setFloors', res.respond.data)
						commit('setCountFloors', res.respond.data.count)
					} else if (res.respond.status == 'forbidden') {
						allMixin.methods.removeSession()
						router.push(`/login`).catch(() => {})
					}
					dispatch('setLoading', false)
				})
				.catch((err) => {
					console.log('authjs=err' + err)
					dispatch('setLoading', false)
					return false
				})
		},
		getRooms({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			api({
				method: 'get',
				url: payload.url,
				// url: `location/area/room`,
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
				.then((res) => {
					if (res.respond.status == 'success') {
						commit('setRooms', res.respond.data)
						commit('setCountRooms', res.respond.data.count)
					} else if (res.respond.status == 'forbidden') {
						allMixin.methods.removeSession()
						router.push(`/login`).catch(() => {})
					}
					dispatch('setLoading', false)
				})
				.catch((err) => {
					console.log('authjs=err' + err)
					dispatch('setLoading', false)
					return false
				})
		},

		getRacks({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			api({
				method: 'get',
				url: payload.url,
				params: payload.params,
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
				.then((res) => {
					if (res.respond.status == 'success') {
						commit('setRacks', res.respond.data)
					} else if (res.respond.status == 'forbidden') {
						allMixin.methods.removeSession()
						router.push(`/login`).catch(() => {})
					}
					dispatch('setLoading', false)
				})
				.catch((err) => {
					console.log('authjs=err' + err)
					dispatch('setLoading', false)
					return false
				})
		},
		getRackDetail({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			return new Promise((resolve, reject) => {
				api({
					method: 'get',
					url: payload.url,
					params: payload.params,
					withCredentials: true,
					headers: {
						Authorization: 'Bearer ' + token
					}
				})
					.then((res) => {
						resolve(res)
						dispatch('setLoading', false)
					})
					.catch((err) => {
						console.log('authjs=err' + err)
						reject(err)
						dispatch('setLoading', false)
						return false
					})
			})
		},

		setLoading({ commit }, payload) {
			commit('loader/setLoading', payload, {
				root: true
			})
		}
	}
}
